import React from "react";
import FormSelect from "./FormSelect";

/**
 * Reusable Advanced Filters panel — a grid of filter dropdowns
 * 
 * @param {Object} filters - Current filter state
 * @param {Function} onFilterChange - (key, value) => void
 * @param {string} sortBy - Current sort value
 * @param {Function} onSortChange - (value) => void
 * @param {Array} sortOptions - Options for Sort By dropdown
 * @param {Array} config - Configuration for other filter fields: [{ key, label, options }]
 */
const AdvancedFilters = ({ 
  filters = {}, 
  onFilterChange, 
  sortBy, 
  onSortChange, 
  sortOptions = [],
  config = [],
}) => {
  return (
    <div className={`card p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 bg-slate-50 animate-in slide-in-from-top-2 border border-slate-200/60 shadow-inner rounded-xl`}>
      {/* Sort By is usually always present */}
      {onSortChange && (
        <FormSelect
          label="Sort By"
          value={sortBy}
          onChange={e => onSortChange(e.target.value)}
          size="sm"
          options={sortOptions}
        />
      )}

      {/* Map through dynamic config */}
      {config.map(({ key, label, options, disabled = false, placeholder = "All" }) => (
        <FormSelect
          key={key}
          label={label}
          value={filters[key] || "all"}
          onChange={e => onFilterChange(key, e.target.value)}
          size="sm"
          disabled={disabled}
          options={[
            { value: "all", label: placeholder },
            ...(options || [])
          ]}
        />
      ))}
    </div>
  );
};

export default AdvancedFilters;




